<template>
    <div v-html="currentTypedText"></div>
</template>

<script>
export default {
    name: "AnimatedText",
    props: {
        value: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            currentTypedText: "",
            timeoutId: null,
            index: 0,
            atLastWord: false,
        }
    },
    methods: {
        typeText() {
            if (this.atLastWord) {
                return
            }
            const currentChar = this.value[this.index]

            if (currentChar === "<") {
                // Skip html tags.
                this.index = this.value.indexOf(">", this.index)
            }
            // Skip to the next space (jump word by word).
            this.index = this.value.indexOf(" ", this.index + 1)
            if (this.index == -1) {
                window.clearTimeout(this.timeoutId)
                this.atLastWord = true
            }
            // Update the currently typed text slice.
            this.currentTypedText = this.value.slice(0, this.index)

            // Add some randomness into the time delay to look more like typing.
            let pauseTime = 80 + Math.round(20 * Math.random())
            // Add an extra long pause when at the end of sentences.
            const lastChar = this.value[this.index - 1]
            if ([".", "!", "?"].includes(lastChar)) {
                pauseTime = 250
            }
            // Set a timeout before 'typing' the next section.
            let vm = this
            this.timeoutId = window.setTimeout(function () {
                vm.typeText()
            }, pauseTime)
        },
    },
    mounted() {
        this.typeText()
    },
    beforeDestroy() {
        this.atLastWord = true
        window.clearTimeout(this.timeoutId)
    },
}
</script>

<style>
</style>